import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { InputField, maxInputTextLength } from '@mews-commander/legacy-form';

export const companyFiscalFieldsConstraints = {
    fiscalIdentifier: { length: maxInputTextLength },
    accountingCode: { length: maxInputTextLength },
    taxIdentifier: { length: maxInputTextLength },
    additionalTaxIdentifier: { length: maxInputTextLength },
    billingCode: { length: maxInputTextLength },
    dunsNumber: {
        format: {
            pattern: '^$|^[0-9]{9}',
            message: { textKey: TextKey.DunsNumberFormatErrorMessage },
        },
    },
};

const fiscalIdentifierProps = {
    name: 'fiscalIdentifier',
    label: <LocalizedText textKey={TextKey.FiscalIdentifier} />,
};

const accountingCodeProps = {
    name: 'accountingCode',
    label: <LocalizedText textKey={TextKey.AccountingCode} />,
};

const taxIdentifierProps = {
    name: 'taxIdentifier',
    label: <LocalizedText textKey={TextKey.TaxIdentifier} />,
};

const additionalTaxIdentifierProps = {
    name: 'additionalTaxIdentifier',
    label: <LocalizedText textKey={TextKey.AdditionalTaxIdentifier} />,
};

const billingCodeProps = {
    name: 'billingCode',
    label: <LocalizedText textKey={TextKey.BillingCode} />,
};

const dunsNumberProps = {
    name: 'dunsNumber',
    label: <LocalizedText textKey={TextKey.DunsNumber} />,
};

export const CompanyFiscalFields = () => (
    <>
        <InputField {...fiscalIdentifierProps} />
        <InputField {...accountingCodeProps} />
        <InputField {...taxIdentifierProps} />
        <InputField {...additionalTaxIdentifierProps} />
        <InputField {...billingCodeProps} />
        <InputField {...dunsNumberProps} />
    </>
);
